var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ED1C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 7.85938L17.043 17.6055H13.9766L13.625 7.85938H17.375ZM15.5 22.2148C14.4453 22.2148 13.5859 21.375 13.6055 20.3203C13.5859 19.2852 14.4453 18.4453 15.5 18.4453C16.4961 18.4453 17.3945 19.2852 17.3945 20.3203C17.3945 21.375 16.4961 22.2148 15.5 22.2148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d9e54cb541a910dfe0e6495a3fd685de.svg";
export { ForwardRef as ReactComponent };